var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_9537)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4417 13.5666C10.3245 13.6837 10.1656 13.7494 10 13.7494C9.83438 13.7494 9.67553 13.6837 9.55834 13.5666L3.30834 7.31663C3.19794 7.19815 3.13784 7.04145 3.14069 6.87953C3.14355 6.71761 3.20914 6.56312 3.32365 6.44861C3.43816 6.3341 3.59265 6.26851 3.75457 6.26565C3.91649 6.2628 4.07319 6.3229 4.19167 6.4333L10 12.2416L15.8083 6.4333C15.8656 6.37189 15.9346 6.32264 16.0112 6.28848C16.0879 6.25432 16.1706 6.23595 16.2546 6.23447C16.3385 6.23299 16.4218 6.24843 16.4997 6.27986C16.5775 6.3113 16.6482 6.35808 16.7075 6.41743C16.7669 6.47678 16.8137 6.54748 16.8451 6.6253C16.8765 6.70312 16.892 6.78648 16.8905 6.8704C16.889 6.95432 16.8706 7.03708 16.8365 7.11375C16.8023 7.19041 16.7531 7.25941 16.6917 7.31663L10.4417 13.5666Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_9537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.4e4f6f334925d41b2c81f6c4d3866e7e.svg";
export { ForwardRef as ReactComponent };